import {
  AUTH_ACCOUNT_REQUEST,
  AUTH_ACCOUNT_SUCCESS,
  AUTH_ACCOUNT_FAILURE,
  STRIPE_PAYMENT_REQUEST,
  STRIPE_PAYMENT_SUCCESS,
  STRIPE_PAYMENT_FAILURE,
  GET_CHARGE_REQUEST,
  GET_CHARGE_SUCCESS,
  GET_CHARGE_FAILURE
} from '../constants';

const initialPxPayState = {
  authAccountLoader: false,
  accountInfo: {},
  authFailed: false,
  authSuccess: false,
  stripePaymentLoader: false,
  chargeLoader: false,
  charge: {},
  stripeFailure: false,
  stripeSuccess: false,
  chargeFailure: false
};

export default (state = initialPxPayState, action = {}) => {
  //This is to ensure immutability of state
  let newState = { ...state };

  switch (action.type) {
    case AUTH_ACCOUNT_REQUEST:
      newState.authFailed = false;
      newState.authSuccess = false;
      newState.authAccountLoader = true;
      return newState;
    case AUTH_ACCOUNT_SUCCESS:
      newState.accountInfo = action.data;
      newState.authSuccess = true;
      newState.authAccountLoader = false;
      return newState;
    case AUTH_ACCOUNT_FAILURE:
      newState.authFailed = true;
      newState.authAccountLoader = false;
      return newState;
    case STRIPE_PAYMENT_REQUEST:
      newState.stripePaymentLoader = true;
      newState.stripeFailure = false;
      newState.stripeSuccess = false;
      return newState;
    case STRIPE_PAYMENT_SUCCESS:
      newState.stripePaymentLoader = false;
      newState.charge = action.data;
      newState.stripeSuccess = true;
      return newState;
    case STRIPE_PAYMENT_FAILURE:
      newState.stripePaymentLoader = false;
      newState.stripeFailure = true;
      return newState;
    case GET_CHARGE_REQUEST:
      newState.stripeFailure = false;
      newState.stripeSuccess = false;
      newState.stripePaymentLoader = false;
      newState.chargeLoader = true;
      newState.chargeFailure = false;
      newState.charge = {};
      return newState;
    case GET_CHARGE_SUCCESS:
      newState.chargeLoader = false;
      newState.charge = action.data;
      newState.chargeFailure = false;
      return newState;
    case GET_CHARGE_FAILURE:
      newState.chargeLoader = false;
      newState.chargeFailure = true;
      return newState;
    default:
      return state;
  }
};
